module.exports = __webpack_public_path__ + "static/media/acionando_recuperacao_senha.4747a44a.png";